import Container from '@wearesection/bandai-react-components/atoms/Container';
import ExploreMore, {
  IExploreMore,
} from '@wearesection/bandai-react-components/organisms/ExploreMore';

import RenderNextImage from '../../atoms/render-next-image';
import {ComponentPropsAdapter} from '../../types';
import {PLACEHOLDER_IMG} from '~/constants';
import {GetRouter, handleTranslateBlogTag, handleReturnColorTag} from '~/utils';
import {handleReturnDateForLocal} from '../scrolling-thumbnail-card/scrolling-thumbnail-card';
import {usePageSetting} from '~/providers/page-context.provider';

type IExploreMOreOrganisms = IExploreMore & {
  items: any;
  listTags: any;
  slug: string;
  layoutBlog?: boolean;
};

const adapter: ComponentPropsAdapter<IExploreMOreOrganisms, IExploreMore> = data => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const {locale} = GetRouter();
  return {
    title: data?.title ?? '',
    viewMore: data?.viewMore,
    classSection: '',
    isBlog: true,
    listThumbnail:
      data?.items?.map((item: any) => ({
        title: item?.title ?? '',
        linkHref: item?.slug ?? '',
        mainImage: item?.mainImage?.media?.url ?? '',
        hrefTag: data?.viewMore?.href,
        mainImageNext: (
          <RenderNextImage
            src={item?.mainImage?.media?.url ?? PLACEHOLDER_IMG}
            width={357}
            height={376}
            alt={item?.title || ''}
          />
        ),
        tags: data?.layoutBlog
          ? [
              {
                title: handleTranslateBlogTag(item?.primaryTag, dataTranslation),
                color: ((data as any)?.listTags ?? [])?.find(
                  (e: any) =>
                    e.name ===
                    handleTranslateBlogTag(
                      item?.primaryTag?.toLocaleLowerCase() as string,
                      dataTranslation
                    )
                )?.backgroundColor,
              },
            ]
          : [
              handleReturnColorTag(
                item?.customTags as string,
                data?.listTags ?? [],
                item?.game?.releaseDate,
                locale
              ),
            ],
        publicDate: handleReturnDateForLocal(locale || '', `${item?.publishDate}`.substring(0, 10)),
      })) ?? [],
  };
};
// layoutBlog
const ExploreMoreOrganisms: React.FC<IExploreMOreOrganisms> = props => {
  const ExploreMoreOrganismsProps = adapter(props);

  return (
    <Container
      sx={{
        paddingTop: {
          xs: '72px',
          lg: '140px',
        },
        paddingBottom: {
          xs: '72px',
          md: '140px',
        },
      }}
    >
      <ExploreMore {...ExploreMoreOrganismsProps} />
    </Container>
  );
};

export default ExploreMoreOrganisms;
